import {
  INVESTORS_URL,
  SERVICE_PROVIDERS_URL,
  COMPANIES_URL
} from 'global-constants';

export const COMPANY_PLACEHOLDERS = {
  company: {
    singular: 'company',
    plural: 'companies',
    link: 'PropTech',
    url: COMPANIES_URL
  },
  serviceProvider: {
    singular: 'service',
    plural: 'services',
    link: 'Services',
    url: SERVICE_PROVIDERS_URL
  },
  investor: {
    singular: 'investor',
    plural: 'investors',
    link: 'Investors',
    url: INVESTORS_URL
  }
};
